// // AdminSettings.jsx
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Button,
// } from '@mui/material';

// function AdminSettings() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [tracks, setTracks] = useState([]);
//   const [showTrackInfo, setShowTrackInfo] = useState(false);
//   const [selectedTrack, setSelectedTrack] = useState(null);

//   useEffect(() => {
//     axios.get('http://localhost:5000/api/dev').then(res => setDevices(res.data));
//     axios.get('http://localhost:5000/api/tracks').then(res => setTracks(res.data));
//   }, []);

//   const handleDeviceChange = (event) => {
//     const device = devices.find(d => d.name_to_assign === event.target.value);
//     setSelectedDevice(device);
//   };

//   const handleTrackChange = (event) => {
//     const track = tracks.find(t => t.id === parseInt(event.target.value));
//     setSelectedTrack(track);
//   };

//   const handleSubmit = async () => {
//     if (!selectedDevice || !selectedTrack) {
//       alert('Please select both device and track section.');
//       return;
//     }

//     try {
//       const response = await axios.post('http://localhost:5000/api/mapDeviceToTrack', {
//         device_name: selectedDevice.name_to_assign,
//         section_id: selectedTrack.id,
//       });

//       if (response.status === 200) {
//         alert('Mapping saved successfully!');
//       } else {
//         alert('Failed to save mapping.');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Error occurred while saving mapping.');
//     }
//   };

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>Admin Settings</Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel>Select Device</InputLabel>
//         <Select value={selectedDevice?.name_to_assign || ''} onChange={handleDeviceChange} label="Select Device">
//           <MenuItem value=""><em>-- Select Device --</em></MenuItem>
//           {devices.map((device) => (
//             <MenuItem key={device.imei} value={device.name_to_assign}>{device.name_to_assign}</MenuItem>
//           ))}
//         </Select>
//       </FormControl>

//       {selectedDevice && (
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography><strong>IMEI:</strong> {selectedDevice.imei}</Typography>
//             <Typography><strong>Provisioned:</strong> {String(selectedDevice.provisioned)}</Typography>
//             <Typography><strong>Provision Timestamp:</strong> {selectedDevice.provision_ts}</Typography>
//             <Typography><strong>Config ID:</strong> {selectedDevice.config_id_to_assign}</Typography>
//             <Typography><strong>Created:</strong> {selectedDevice.created_ts}</Typography>
//           </CardContent>
//         </Card>
//       )}

//       <FormControlLabel
//         control={<Checkbox checked={showTrackInfo} onChange={(e) => setShowTrackInfo(e.target.checked)} />}
//         label="Show Track Sections"
//       />

//       {showTrackInfo && (
//         <>
//           <FormControl fullWidth sx={{ mt: 2 }}>
//             <InputLabel>Select Track Section ID</InputLabel>
//             <Select
//               value={selectedTrack?.id || ''}
//               onChange={handleTrackChange}
//               label="Select Track Section ID"
//             >
//               <MenuItem value=""><em>-- Select Track --</em></MenuItem>
//               {tracks.map((track) => (
//                 <MenuItem key={track.id} value={track.id}>{track.id}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {selectedTrack && (
//             <Card sx={{ mt: 3, backgroundColor: '#e3f2fd' }}>
//               <CardContent>
//                 <Typography><strong>Track ID:</strong> {selectedTrack.id}</Typography>
//                 <Typography><strong>Up Station ID:</strong> {selectedTrack.up_station_id}</Typography>
//                 <Typography><strong>Down Station ID:</strong> {selectedTrack.down_station_id}</Typography>
//                 <Typography><strong>Config:</strong> {selectedTrack.config_id || 'N/A'}</Typography>
//               </CardContent>
//             </Card>
//           )}

//           {selectedDevice && selectedTrack && (
//             <Box sx={{ mt: 2 }}>
//               <Button variant="contained" color="primary" onClick={handleSubmit}>
//                 Submit Mapping
//               </Button>
//             </Box>
//           )}
//         </>
//       )}
//     </Box>
//   );
// }

// export default AdminSettings;
//////////////////////////////////////////////////////////////////////////////////22222222222222222222222222222222222222222222222222222222222222

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
// } from '@mui/material';

// function AdminSettings() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [tracks, setTracks] = useState([]);
//   const [showTrackTable, setShowTrackTable] = useState(false);
//   const [selectedTracks, setSelectedTracks] = useState({}); // { section_id: { allowed: boolean } }

//   useEffect(() => {
//     axios.get('http://localhost:5000/api/dev').then(res => setDevices(res.data));
//     axios.get('http://localhost:5000/api/tracks').then(res => setTracks(res.data));
//   }, []);

//   const handleDeviceChange = (event) => {
//     const device = devices.find(d => d.name_to_assign === event.target.value);
//     setSelectedDevice(device);
//   };

//   const toggleSectionSelection = (sectionId) => {
//     setSelectedTracks(prev => {
//       const updated = { ...prev };
//       if (updated[sectionId]) {
//         delete updated[sectionId];
//       } else {
//         updated[sectionId] = { allowed: false }; // default allowed false
//       }
//       return updated;
//     });
//   };

//   const toggleAllowed = (sectionId) => {
//     setSelectedTracks(prev => ({
//       ...prev,
//       [sectionId]: {
//         ...prev[sectionId],
//         allowed: !prev[sectionId].allowed,
//       }
//     }));
//   };

//   const handleSubmit = async () => {
//     if (!selectedDevice || Object.keys(selectedTracks).length === 0) {
//       alert('Please select a device and at least one track section.');
//       return;
//     }

//     const payload = Object.entries(selectedTracks).map(([sectionId, data]) => ({
//       section_id: parseInt(sectionId),
//       allowed: data.allowed
//     }));

//     try {
//       const response = await axios.post('http://localhost:5000/api/mapMultipleTracksWithAllowed', {
//         device_name: selectedDevice.name_to_assign,
//         mappings: payload,
//       });

//       if (response.status === 200) {
//         alert('Mappings saved successfully!');
//         setSelectedTracks({});
//       } else {
//         alert('Failed to save mappings.');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Error occurred while saving mappings.');
//     }
//   };

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>Admin Settings</Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel>Select Device</InputLabel>
//         <Select value={selectedDevice?.name_to_assign || ''} onChange={handleDeviceChange} label="Select Device">
//           <MenuItem value=""><em>-- Select Device --</em></MenuItem>
//           {devices.map((device) => (
//             <MenuItem key={device.imei} value={device.name_to_assign}>{device.name_to_assign}</MenuItem>
//           ))}
//         </Select>
//       </FormControl>

//       <FormControlLabel
//         control={<Checkbox checked={showTrackTable} onChange={(e) => setShowTrackTable(e.target.checked)} />}
//         label="Show Track Sections Table"
//       />

//       {showTrackTable && (
//         <Paper sx={{ mt: 3 }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Select</TableCell>
//                 <TableCell>Section ID</TableCell>
//                 <TableCell>Up Station ID</TableCell>
//                 <TableCell>Down Station ID</TableCell>
//                 <TableCell>Allowed</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {tracks.map((track) => {
//                 const isSelected = !!selectedTracks[track.id];
//                 return (
//                   <TableRow key={track.id}>
//                     <TableCell>
//                       <Checkbox
//                         checked={isSelected}
//                         onChange={() => toggleSectionSelection(track.id)}
//                       />
//                     </TableCell>
//                     <TableCell>{track.id}</TableCell>
//                     <TableCell>{track.up_station_id}</TableCell>
//                     <TableCell>{track.down_station_id}</TableCell>
//                     <TableCell>
//                       <Checkbox
//                         checked={selectedTracks[track.id]?.allowed || false}
//                         disabled={!isSelected}
//                         onChange={() => toggleAllowed(track.id)}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}

//       {selectedDevice && Object.keys(selectedTracks).length > 0 && (
//         <Box sx={{ mt: 2 }}>
//           <Button variant="contained" color="primary" onClick={handleSubmit}>
//             Submit Mapping
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// }

// export default AdminSettings;

////////////////////333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Button,
//   FormControlLabel,
//   Stack,
// } from '@mui/material';

// function AdminSettings() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [tracks, setTracks] = useState([]);
//   const [showTable, setShowTable] = useState(false);
//   const [allowedTracks, setAllowedTracks] = useState({}); // { section_id: true/false }

//   useEffect(() => {
//     axios.get('http://localhost:5000/api/dev').then(res => setDevices(res.data));
//     axios.get('http://localhost:5000/api/tracks').then(res => setTracks(res.data));
//   }, []);

//   const handleDeviceChange = (event) => {
//     const device = devices.find(d => d.name_to_assign === event.target.value);
//     setSelectedDevice(device);
//   };

//   const toggleAllowed = (sectionId) => {
//     setAllowedTracks(prev => ({
//       ...prev,
//       [sectionId]: !prev[sectionId],
//     }));
//   };

//   const getAllowedMappings = () => {
//     return Object.entries(allowedTracks)
//       .filter(([_, allowed]) => allowed)
//       .map(([section_id]) => ({
//         section_id: parseInt(section_id),
//         allowed: true,
//       }));
//   };

//   const handleSubmit = async () => {
//     if (!selectedDevice) return alert('Please select a device.');

//     const mappings = getAllowedMappings();
//     if (mappings.length === 0) return alert('No tracks marked as allowed.');

//     try {
//       const response = await axios.post('http://localhost:5000/api/mapMultipleTracksWithAllowed', {
//         device_name: selectedDevice.name_to_assign,
//         mappings,
//       });

//       if (response.status === 200) {
//         alert('Mappings saved successfully!');
//         setAllowedTracks({});
//       } else {
//         alert('Failed to save mappings.');
//       }
//     } catch (error) {
//       console.error('Submit error:', error);
//       alert('An error occurred while saving.');
//     }
//   };

//   const handleDelete = async () => {
//     if (!selectedDevice) return alert('Please select a device.');

//     const mappings = getAllowedMappings();
//     if (mappings.length === 0) return alert('No tracks marked to delete.');

//     try {
//       const response = await axios.post('http://localhost:5000/api/deleteMappedTracks', {
//         device_name: selectedDevice.name_to_assign,
//         mappings,
//       });

//       if (response.status === 200) {
//         alert('Mappings deleted successfully!');
//         setAllowedTracks({});
//       } else {
//         alert('Failed to delete mappings.');
//       }
//     } catch (error) {
//       console.error('Delete error:', error);
//       alert('An error occurred while deleting.');
//     }
//   };

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>Admin Settings</Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel>Select Device</InputLabel>
//         <Select value={selectedDevice?.name_to_assign || ''} onChange={handleDeviceChange} label="Select Device">
//           <MenuItem value=""><em>-- Select Device --</em></MenuItem>
//           {devices.map((device) => (
//             <MenuItem key={device.imei} value={device.name_to_assign}>{device.name_to_assign}</MenuItem>
//           ))}
//         </Select>
//       </FormControl>

//       <FormControlLabel
//         control={<Checkbox checked={showTable} onChange={(e) => setShowTable(e.target.checked)} />}
//         label="Track Sections Table"
//       />

//       {showTable && (
//         <Paper sx={{ mt: 3 }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell><strong>Section ID</strong></TableCell>
//                 <TableCell><strong>Up Station ID</strong></TableCell>
//                 <TableCell><strong>Down Station ID</strong></TableCell>
//                 <TableCell><strong>Allowed</strong></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {tracks.map((track) => (
//                 <TableRow key={track.id}>
//                   <TableCell>{track.id}</TableCell>
//                   <TableCell>{track.up_station_id}</TableCell>
//                   <TableCell>{track.down_station_id}</TableCell>
//                   <TableCell>
//                     <Checkbox
//                       checked={allowedTracks[track.id] || false}
//                       onChange={() => toggleAllowed(track.id)}
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}

//       {showTable && selectedDevice && (
//         <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
//           <Button variant="contained" color="primary" onClick={handleSubmit}>
//             Submit Allowed Tracks
//           </Button>
//           <Button variant="outlined" color="error" onClick={handleDelete}>
//             Delete Allowed Tracks
//           </Button>
//         </Stack>
//       )}
//     </Box>
//   );
// }

// export default AdminSettings;

//////////////////////////////////////////////NEW
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box, Typography, FormControl, InputLabel, Select, MenuItem,
//   Checkbox, Table, TableHead, TableRow, TableCell, TableBody,
//   Paper, Button, Stack
// } from '@mui/material';

// function AdminSettings() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [tracks, setTracks] = useState([]);
//   const [deviceMappings, setDeviceMappings] = useState([]); // section_ids from DB
//   const [checkedTracks, setCheckedTracks] = useState({});

//   useEffect(() => {
//     axios.get('http://localhost:5000/api/dev').then(res => setDevices(res.data));
//     axios.get('http://localhost:5000/api/tracks').then(res => setTracks(res.data));
//   }, []);

//   useEffect(() => {
//     if (selectedDevice) {
//       axios
//         .post('http://localhost:5000/api/getDeviceMappings', { device_name: selectedDevice.name_to_assign })
//         .then(res => {
//           const sectionIds = res.data.map(row => row.section_id);
//           const newChecked = {};
//           sectionIds.forEach(id => {
//             newChecked[id] = true;
//           });
//           setDeviceMappings(sectionIds);
//           setCheckedTracks(newChecked);
//         });
//     }
//   }, [selectedDevice]);

//   const handleDeviceChange = (event) => {
//     const device = devices.find(d => d.name_to_assign === event.target.value);
//     setSelectedDevice(device);
//   };

//   const toggleTrack = (id) => {
//     setCheckedTracks(prev => ({ ...prev, [id]: !prev[id] }));
//   };

//   const getTracksToEnable = () => {
//     return Object.entries(checkedTracks)
//       .filter(([id, checked]) => checked && !deviceMappings.includes(Number(id)))
//       .map(([id]) => ({ section_id: Number(id), allowed: true }));
//   };

//   const getTracksToDisable = () => {
//     return Object.entries(checkedTracks)
//       .filter(([id, checked]) => !checked && deviceMappings.includes(Number(id)))
//       .map(([id]) => ({ section_id: Number(id), allowed: false }));
//   };

//   const handleAction = async () => {
//     if (!selectedDevice) return alert("Select a device");

//     const toEnable = getTracksToEnable();
//     const toDisable = getTracksToDisable();

//     try {
//       if (toEnable.length > 0) {
//         const res = await axios.post('http://localhost:5000/api/mapMultipleTracksWithAllowed', {
//           device_name: selectedDevice.name_to_assign,
//           mappings: toEnable,
//         });
//         if (res.status === 200) alert("Enabled tracks successfully");
//       } else if (toDisable.length > 0) {
//         const res = await axios.post('http://localhost:5000/api/deleteMappedTracks', {
//           device_name: selectedDevice.name_to_assign,
//           mappings: toDisable,
//         });
//         if (res.status === 200) alert("Disabled tracks successfully");
//       } else {
//         alert("No changes made.");
//       }
//       setCheckedTracks({});
//       setSelectedDevice(null);
//     } catch (error) {
//       console.error("Action error", error);
//       alert("Error while updating mappings");
//     }
//   };

//   const showEnable = getTracksToEnable().length > 0;
//   const showDisable = getTracksToDisable().length > 0;

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>Admin Settings</Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel>Select Device</InputLabel>
//         <Select value={selectedDevice?.name_to_assign || ''} onChange={handleDeviceChange}>
//           <MenuItem value=""><em>-- Select Device --</em></MenuItem>
//           {devices.map(d => (
//             <MenuItem key={d.imei} value={d.name_to_assign}>{d.name_to_assign}</MenuItem>
//           ))}
//         </Select>
//       </FormControl>

//       {selectedDevice && (
//         <>
//           <Paper sx={{ mt: 2 }}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Section ID</TableCell>
//                   <TableCell>Up Station ID</TableCell>
//                   <TableCell>Down Station ID</TableCell>
//                   <TableCell>Allowed</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {tracks.map(track => (
//                   <TableRow key={track.id}>
//                     <TableCell>{track.id}</TableCell>
//                     <TableCell>{track.up_station_id}</TableCell>
//                     <TableCell>{track.down_station_id}</TableCell>
//                     <TableCell>
//                       <Checkbox
//                         checked={!!checkedTracks[track.id]}
//                         onChange={() => toggleTrack(track.id)}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </Paper>

//           {(showEnable || showDisable) && (
//             <Button
//               sx={{ mt: 2 }}
//               variant="contained"
//               color={showEnable ? "primary" : "error"}
//               onClick={handleAction}
//             >
//               {showEnable ? "Enable" : "Disable"}
//             </Button>
//           )}
//         </>
//       )}
//     </Box>
//   );
// }

// export default AdminSettings;
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box, Typography, FormControl, InputLabel, Select, MenuItem,
//   Checkbox, Table, TableHead, TableRow, TableCell, TableBody,
//   Paper, Button
// } from '@mui/material';

// function AdminSettings() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [tracks, setTracks] = useState([]);
//   const [deviceMappings, setDeviceMappings] = useState([]);
//   const [checkedTracks, setCheckedTracks] = useState({});
//   const [sectionNames, setSectionNames] = useState({});

//   useEffect(() => {
//     axios.get('http://localhost:5000/api/dev').then(res => setDevices(res.data));
//     axios.get('http://localhost:5000/api/tracks').then(res => setTracks(res.data));
//     axios.get('http://localhost:5000/api/deviceConfigs').then(res => {
//       const map = {};
//       res.data.forEach(cfg => {
//         map[cfg.id] = cfg.name?.trim() || null;
//       });
//       setSectionNames(map);
//     });
//   }, []);

//   useEffect(() => {
//     if (selectedDevice) {
//       axios.post('http://localhost:5000/api/getDeviceMappings', { device_name: selectedDevice.name_to_assign })
//         .then(res => {
//           const sectionIds = res.data.map(row => row.section_id);
//           const newChecked = {};
//           sectionIds.forEach(id => {
//             newChecked[id] = true;
//           });
//           setDeviceMappings(sectionIds);
//           setCheckedTracks(newChecked);
//         });
//     } else {
//       setDeviceMappings([]);
//       setCheckedTracks({});
//     }
//   }, [selectedDevice]);

//   const handleDeviceChange = (event) => {
//     const device = devices.find(d => d.name_to_assign === event.target.value);
//     setSelectedDevice(device);
//   };

//   const toggleTrack = (id) => {
//     setCheckedTracks(prev => ({ ...prev, [id]: !prev[id] }));
//   };

//   const getTracksToEnable = () => Object.entries(checkedTracks)
//     .filter(([id, checked]) => checked && !deviceMappings.includes(Number(id)))
//     .map(([id]) => ({ section_id: Number(id), allowed: true }));

//   const getTracksToDisable = () => Object.entries(checkedTracks)
//     .filter(([id, checked]) => !checked && deviceMappings.includes(Number(id)))
//     .map(([id]) => ({ section_id: Number(id), allowed: false }));

//   const handleAction = async () => {
//     if (!selectedDevice) {
//       alert("Select a device");
//       return;
//     }

//     const toEnable = getTracksToEnable();
//     const toDisable = getTracksToDisable();

//     try {
//       if (toEnable.length > 0) {
//         const res = await axios.post('http://localhost:5000/api/mapMultipleTracksWithAllowed', {
//           device_name: selectedDevice.name_to_assign,
//           mappings: toEnable,
//         });
//         if (res.status === 200) alert("Enabled tracks successfully");
//       } 
//       if (toDisable.length > 0) {
//         const res = await axios.post('http://localhost:5000/api/deleteMappedTracks', {
//           device_name: selectedDevice.name_to_assign,
//           mappings: toDisable,
//         });
//         if (res.status === 200) alert("Disabled tracks successfully");
//       }
//       if (toEnable.length === 0 && toDisable.length === 0) {
//         alert("No changes made.");
//       }
//       setCheckedTracks({});
//       setSelectedDevice(null);
//     } catch (error) {
//       console.error("Action error", error);
//       alert("Error while updating mappings");
//     }
//   };

//   const showEnable = getTracksToEnable().length > 0;
//   const showDisable = getTracksToDisable().length > 0;

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>
//         Section Permission Enable/Disable Settings
//       </Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel id="device-select-label">Select Device</InputLabel>
//         <Select
//           labelId="device-select-label"
//           value={selectedDevice?.name_to_assign || ''}
//           label="Select Device"
//           onChange={handleDeviceChange}
//         >
//           <MenuItem value="">
//             <em>-- Select Device --</em>
//           </MenuItem>
//           {devices.map(d => (
//             <MenuItem key={d.imei} value={d.name_to_assign}>
//               {d.name_to_assign}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>

//       {selectedDevice && (
//         <>
//           <Paper sx={{ mt: 2 }}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Track Sections ID</TableCell>
//                   <TableCell>Up Station ID</TableCell>
//                   <TableCell>Down Station ID</TableCell>
//                   <TableCell>Allowed</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {tracks.map(track => (
//                   <TableRow key={track.id}>
//                    {/* <TableCell>{sectionNames[track.id] || track.id}</TableCell> */}
//                     <TableCell>{track.id}</TableCell>
//                     <TableCell>{track.up_station_id}</TableCell>
//                     <TableCell>{track.down_station_id}</TableCell>
//                     <TableCell>
//                       <Checkbox
//                         checked={!!checkedTracks[track.id]}
//                         onChange={() => toggleTrack(track.id)}
//                         inputProps={{ 'aria-label': `allow track ${track.id}` }}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </Paper>

//           {(showEnable || showDisable) && (
//             <Button
//               sx={{ mt: 2 }}
//               variant="contained"
//               color={showEnable ? "primary" : "error"}
//               onClick={handleAction}
//             >
//               {showEnable ? "Enable" : "Disable"}
//             </Button>
//           )}
//         </>
//       )}
//     </Box>
//   );
// }

// export default AdminSettings;
import React, { useEffect, useState } from 'react';
import axios from './AxiosInstance';
import {
  Box, Typography, FormControl, InputLabel, Select, MenuItem,
  Checkbox, Table, TableHead, TableRow, TableCell, TableBody,
  Paper, Button
} from '@mui/material';

function AdminSettings() {
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [tracks, setTracks] = useState([]);
  const [deviceMappings, setDeviceMappings] = useState([]);
  const [checkedTracks, setCheckedTracks] = useState({});
 // const [sectionNames, setSectionNames] = useState({});

  useEffect(() => {
    axios.get('/api/dev').then(res => setDevices(res.data));
    axios.get('/api/tracks').then(res => setTracks(res.data));
    axios.get('/api/deviceConfigs').then(res => {
      const map = {};
      res.data.forEach(cfg => {
        map[cfg.id] = cfg.name?.trim() || null;
      });
     // setSectionNames(map);
    });
  }, []);

  useEffect(() => {
    if (selectedDevice) {
      axios.post('/api/getDeviceMappings', { device_name: selectedDevice.name_to_assign })
        .then(res => {
          const sectionIds = res.data.map(row => row.section_id);
          const newChecked = {};
          sectionIds.forEach(id => {
            newChecked[id] = true;
          });
          setDeviceMappings(sectionIds);
          setCheckedTracks(newChecked);
        });
    } else {
      setDeviceMappings([]);
      setCheckedTracks({});
    }
  }, [selectedDevice]);

  const handleDeviceChange = (event) => {
    const device = devices.find(d => d.name_to_assign === event.target.value);
    setSelectedDevice(device);
  };

  const toggleTrack = (id) => {
    setCheckedTracks(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const getTracksToEnable = () => Object.entries(checkedTracks)
    .filter(([id, checked]) => checked && !deviceMappings.includes(Number(id)))
    .map(([id]) => ({ section_id: Number(id), allowed: true }));

  const getTracksToDisable = () => Object.entries(checkedTracks)
    .filter(([id, checked]) => !checked && deviceMappings.includes(Number(id)))
    .map(([id]) => ({ section_id: Number(id), allowed: false }));

  const handleAction = async () => {
    if (!selectedDevice) {
      alert("Select a device");
      return;
    }

    const toEnable = getTracksToEnable();
    const toDisable = getTracksToDisable();

    try {
      if (toEnable.length > 0) {
        const res = await axios.post('/api/mapMultipleTracksWithAllowed', {
          device_name: selectedDevice.name_to_assign,
          mappings: toEnable,
        });
        if (res.status === 200) alert("Enabled tracks successfully");
      }
      if (toDisable.length > 0) {
        const res = await axios.post('/api/deleteMappedTracks', {
          device_name: selectedDevice.name_to_assign,
          mappings: toDisable,
        });
        if (res.status === 200) alert("Disabled tracks successfully");
      }
      if (toEnable.length === 0 && toDisable.length === 0) {
        alert("No changes made.");
      }
      setCheckedTracks({});
      setSelectedDevice(null);
    } catch (error) {
      console.error("Action error", error);
      alert("Error while updating mappings");
    }
  };

  const showEnable = getTracksToEnable().length > 0;
  const showDisable = getTracksToDisable().length > 0;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Section Permission Enable/Disable Settings
      </Typography>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel id="device-select-label">Select Device</InputLabel>
        <Select
          labelId="device-select-label"
          value={selectedDevice?.name_to_assign || ''}
          label="Select Device"
          onChange={handleDeviceChange}
        >
          <MenuItem value="">
            <em>-- Select Device --</em>
          </MenuItem>
          {devices.map(d => (
            <MenuItem key={d.imei} value={d.name_to_assign}>
              {d.name_to_assign}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedDevice && (
        <>
          <Paper sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Track Section ID</TableCell>
                  <TableCell>Up Station Name</TableCell>
                  <TableCell>Down Station Name</TableCell>
                  <TableCell>Allowed</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tracks.map(track => (
                  <TableRow key={track.id}>
                    <TableCell>{track.id}</TableCell>
                    <TableCell>{track.up_station_name || track.up_station_id}</TableCell>
                    <TableCell>{track.down_station_name || track.down_station_id}</TableCell>
                    <TableCell>
                      <Checkbox
                        checked={!!checkedTracks[track.id]}
                        onChange={() => toggleTrack(track.id)}
                        inputProps={{ 'aria-label': `allow track ${track.id}` }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>

          {(showEnable || showDisable) && (
            <Button
              sx={{ mt: 2 }}
              variant="contained"
              color={showEnable ? "primary" : "error"}
              onClick={handleAction}
            >
              {showEnable ? "Enable" : "Disable"}
            </Button>
          )}
        </>
      )}
    </Box>
  );
}

export default AdminSettings;
